import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, LicitacoesReducer, LicitacoesState } from "./licitacoes-reducer";
import { PaginationResponse } from "models/pagination-response";
import { ILicitacaoPagedResponse } from "models/response/licitacao-paged-response";

const LicitacoesContext = createContext<LicitacoesState | undefined>(undefined);
const LicitacoesContextDispatchContext = createContext({} as any);

const LicitacoesProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(LicitacoesReducer, {
        licitacoes: new PaginationResponse<ILicitacaoPagedResponse>([], 0, 1, 10, 0),
        licitacoesPagedRequest: { page: 0, pageSize: 10 },
        orgaos: [],
        modalidades: [],
        fases: [],
        situacoes: [],
        ultimaAtualizacao: null,
        loading: false,
        error: null
    } as LicitacoesState);

    return (
        <LicitacoesContext.Provider value={state}>
            <LicitacoesContextDispatchContext.Provider value={dispatch}>
                {children}
            </LicitacoesContextDispatchContext.Provider>
        </LicitacoesContext.Provider>
    );
}

const useLicitacoesState = () => {
    const context = useContext(LicitacoesContext);
    if (context === undefined) {
        throw new Error('useLicitacoesState must be used within a LicitacoesProvider');
    }
    return context;
}

const useLicitacoesDispatch = () => {
    const context = useContext(LicitacoesContextDispatchContext);
    if (context === undefined) {
        throw new Error('useLicitacoesDispatch must be used within a LicitacoesProvider');
    }
    return context;
}

export { LicitacoesProvider, useLicitacoesState, useLicitacoesDispatch, ACTION_TYPES };
